var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIngressi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "25px",
    viewBox: "0 -20 512.00788 512",
    width: "25px",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "XMLID_1000_"
  }, /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1078_",
    d: "M453.769,68.778H51.788C23.232,68.778,0,92.011,0,120.566V384.99c0,28.556,23.232,51.788,51.788,51.788   h401.98c28.556,0,51.788-23.232,51.788-51.788V120.566C505.557,92.011,482.324,68.778,453.769,68.778z M30,384.99v-46.299h52.061   v68.087H51.788C39.774,406.778,30,397.004,30,384.99z M475.557,384.99c0,12.014-9.774,21.788-21.788,21.788H112.061v-83.087   c0-8.284-6.716-15-15-15H30V120.566c0-12.014,9.774-21.788,21.788-21.788h401.98c12.014,0,21.788,9.774,21.788,21.788V384.99z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1080_",
    d: "M292.869,214.402c-5.882,5.834-5.92,15.331-0.086,21.213c9.069,9.144,8.93,24.04-0.312,33.207   c-5.882,5.834-5.92,15.331-0.086,21.213c2.933,2.957,6.79,4.437,10.649,4.437c3.818,0,7.639-1.449,10.563-4.351   c20.985-20.816,21.202-54.744,0.483-75.633C308.248,208.608,298.75,208.568,292.869,214.402z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1081_",
    d: "M356.155,189.911c-5.835-5.883-15.331-5.92-21.213-0.086s-5.92,15.331-0.086,21.213   c22.406,22.589,22.107,59.345-0.667,81.936c-5.882,5.834-5.92,15.331-0.086,21.213c2.933,2.957,6.79,4.437,10.649,4.437   c3.818,0,7.639-1.449,10.563-4.351C389.835,280.032,390.211,224.244,356.155,189.911z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1082_",
    d: "M370.59,152.746c-5.882,5.834-5.92,15.331-0.086,21.213c42.586,42.933,42.045,112.765-1.206,155.666   c-5.882,5.834-5.92,15.331-0.086,21.213c2.933,2.957,6.79,4.437,10.649,4.437c3.818,0,7.639-1.449,10.563-4.351   c54.995-54.551,55.613-143.414,1.378-198.092C385.968,146.951,376.472,146.912,370.59,152.746z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1083_",
    d: "M216.976,147.986H78.072c-8.284,0-15,6.716-15,15s6.716,15,15,15h138.903c8.284,0,15-6.716,15-15   S225.26,147.986,216.976,147.986z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "XMLID_1084_",
    d: "M147.523,206.398H83.778c-8.284,0-15,6.716-15,15s6.716,15,15,15h63.745c8.284,0,15-6.716,15-15   S155.808,206.398,147.523,206.398z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIngressi);
export default __webpack_public_path__ + "static/media/ingressi.c4523b9d.svg";
export { ForwardRef as ReactComponent };